exports.components = {
  "component---src-page-templates-index-tsx": () => import("./../../../src/page-templates/index.tsx" /* webpackChunkName: "component---src-page-templates-index-tsx" */),
  "component---src-page-templates-privacy-policy-tsx": () => import("./../../../src/page-templates/privacy-policy.tsx" /* webpackChunkName: "component---src-page-templates-privacy-policy-tsx" */)
}

